<script lang="ts" setup>
import Badge from '@/components/common/Badge.vue';
import { getCurrentInstance, onMounted, ref, computed } from 'vue';
import { Status } from '@/components/common/editors/saveStatus/SaveStatuses';

export type GroupBadgeData = { text: string; badge: string; status: Status };

const currentInstance = ref<any>(null);

const params = computed(() => {
    if (currentInstance.value != null && 'params' in currentInstance.value) {
        const key = currentInstance.value.params?.node?.key as string ?? null;
        if (currentInstance?.value?.params != null && 'getValues' in currentInstance.value.params) {
            return currentInstance.value?.params?.getValues(key) ?? null;
        }
    }

    return null;
});

onMounted(() => {
    currentInstance.value = getCurrentInstance()?.proxy;
});
</script>

<template>
    <div class="flex-container align-center-middle">
        <span>{{ params?.text }}</span>
        <Badge
            class="margin-left-3"
            :text="params?.badge ?? ''"
            :small="true"
            :status="params?.status ?? Status.Info"
        />
    </div>
</template>
